import { HttpClient } from '@angular/common/http';
import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { NbSearchService } from '@nebular/theme';
import { Subject } from 'rxjs';
import { Subscription } from 'rxjs/internal/Subscription';
import { EnvService } from 'src/app/env.service';
import { liveSearch } from '../dash.operator';
import { DashService } from '../dash.service';
import { UserDetailComponent } from '../user-detail/user-detail.component';

@Component({
  selector: 'app-hub-transfer',
  templateUrl: './hub-transfer.component.html',
  styleUrls: ['./hub-transfer.component.css']
})
export class HubTransferComponent implements OnInit {
  custInfo: any;
  fromHubId = "N/A"
  fromUser = "N/A"
  toUser = ""
  searchValue = " "
  custDatas = [];
  showSearchCard = false;
  isLoading = false;

  constructor(public userDetails: UserDetailComponent, private route: ActivatedRoute, private http: HttpClient, private router: Router, public dashService: DashService, private env: EnvService) {
  }


  ngOnInit(): void {
    this.verifyUser()
  }


  verifyUser() {
    var pin = prompt("Please enter passcode to continue.")

    if (pin) {
      this.http.post(this.env.apiUrl + "/api/users/verifyUserPin", { pin: pin })
        .subscribe(response => {
          console.log(response)
          this.userDetails.showToast(3000, response['message'], 'validating')
          this.route.params.subscribe(params => {
            console.log(params.hubId)
            this.fromHubId = params.hubId.split("|")[0]
            this.fromUser = params.hubId.split("|")[1]
          });
          setTimeout(() => {
            this.searchUsers(this.searchValue);
            // this.isLoading = false;
          }, 1500);
        }, err => {
          console.log(err)
          // this.verifyUser()
          setTimeout(() => {
            this.userDetails.showToast(3000, err['message'], 'reloading page')
            location.reload()
          }, 3000);
        })
    } else {
      console.log("enter pin")
      this.verifyUser()
    }
  }


  transferAll = false;

  markTransferAll(checked: boolean) {
    this.transferAll = checked;
  }

  transfer() {
    this.isLoading = true;
    this.http.get(this.env.apiUrl + "/api/hubTransfer/transfer?fromHubId=" + this.fromHubId + "&fromUser=" + this.fromUser + "&toUser=" + this.toUser + "&multi=" + this.transferAll)
      .subscribe(response => {
        console.log(response);
        this.userDetails.showToast(2000, "Transferred Successfully", "hub transferred to new account");
        setTimeout(() => {
          this.isLoading = false
          this.router.navigate(['users']);
        }, 2000);
      }, err => {
        this.isLoading = false
        console.log(err);
      })
  }

  searchUsers(query: string) {
    // console.log("search Users: " + query)
    this.searchValue = query
    this.userQuerySubject.next(this.searchValue + "," + false + "," + false + ',' + 0 + "," + 10);
  }

  private userQuerySubject = new Subject<string>();

  readonly custDatas$ = this.userQuerySubject.pipe(
    liveSearch(query => this.dashService.fetchUsers(query))
  );

  setData(item: any) {
    this.toUser = item['emailId'] ? item['emailId'] : item['mobile'];
    this.showSearchCard = false;
  }

}
